import { render, staticRenderFns } from "./SearchResultsPanel.vue?vue&type=template&id=49339fc4&scoped=true&"
import script from "./SearchResultsPanel.vue?vue&type=script&setup=true&lang=js&"
export * from "./SearchResultsPanel.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./SearchResultsPanel.vue?vue&type=style&index=0&id=49339fc4&prod&lang=css&"
import style1 from "./SearchResultsPanel.vue?vue&type=style&index=1&id=49339fc4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49339fc4",
  null
  
)

export default component.exports